import { Component, EventEmitter, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Util } from 'src/app/libraries/Utils';
import { NotificationService } from 'src/app/modules/shared/services/notification/notification.service';

@Component({
  selector: 'app-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.sass']
})
export class NotificationComponent {
  @Input() roleChanged!: any;
  @Input() menuOpened!: any;

  notifications: any[] = [];
  showUnread: boolean = true;
  color = '#00875A';
  statusValue = 'N';
  util = new Util();
  isLoading: boolean = false;
  unseenCount: any = 0;

  constructor(private notificationService: NotificationService, private toastr: ToastrService,
    private router: Router
  ) { 
    this.loadNotifications(this.statusValue);
  }

  ngOnInit(): void {
    this.loadNotifications(this.statusValue);
  }
  
  ngOnChanges(): void {
    this.loadNotifications(this.statusValue);
  }

  async loadNotifications(status: string){
    this.isLoading = true;
    const user = localStorage.getItem('user');
    this.notificationService.getNotifications(status).subscribe({
      next: (data: any) => {
        if (user === 'BK') {
          this.notifications = data.filter((item: any) => !item.notificationTo);
        } else {
          this.notifications = data.filter((item: any) => item.notificationTo);
        }
        this.unseenCount = this.notifications.filter((item: any) => item.isRead === 'N').length;
        this.isLoading = false;
      },
      error: (err: any) => {
        console.log(err);
        this.isLoading = false;
        // this.toastr.error('Es ist ein Fehler aufgetreten. Die Daten konnten nicht geladen werden');
      }
    });
  }

  toggleSwitch() {
    this.isLoading = true;
    this.showUnread = !this.showUnread;
    if (this.showUnread) {
      this.statusValue = 'N';
      this.loadNotifications(this.statusValue);
    } else {
      this.statusValue = '';
      this.loadNotifications(this.statusValue);
    }
  }

  markAsRead(notificationId: number) {
    this.notificationService.markAsRead(notificationId).subscribe({
      next: async (data: any) => {
        await this.loadNotifications(this.statusValue);
        this.toastr.success('Benachrichtigung als gelesen markiert');
        setTimeout(() => {
          sessionStorage.setItem('unseenCount', this.unseenCount);
        }, 1000);
      },
      error: (err: any) => {
        this.toastr.error('Es ist ein Fehler aufgetreten');
        this.isLoading = false;
      }
    });
  }

  markAllAsRead() {
    this.isLoading = true;
    this.notificationService.markAllAsRead().subscribe({
      next: async (data: any) => {
        await this.loadNotifications(this.statusValue);
        this.toastr.success('Alle Benachrichtigungen als gelesen markiert');
        setTimeout(() => {
          sessionStorage.setItem('unseenCount', this.unseenCount);
        }, 1000);
      },
      error: (err: any) => {
        this.toastr.error('Es ist ein Fehler aufgetreten');
        this.isLoading = false;
      }
    });
  }

  goToForm(notification: any) {
    this.markAsRead(notification.id);
    this.router.navigate(['/travel-form', notification.expenseId]);
  }
}
